import Footer from "@app/components/Footer";
import Header from "@app/components/Header";
import ScrollToTop from "@components/ScrollToTop/ScrollToTop";
import { ThemeEnum } from "@components/ThemeProvider/ThemeProvider";
import { useIsArticlePage } from "@src/app/hooks/useIsArticlePage";
import { useLocation } from "react-router";

import { useDfpPreview } from "../_ads/_hooks/useDfpPreview";
import CatfishAd from "../_ads/GoogleAd/CatfishAd";
import GoogleAd, { GoogleAdTypeEnum } from "../_ads/GoogleAd/GoogleAd";

type CommonRenderProps = {
  children: React.ReactNode;
};

export default function CommonRender({ children }: CommonRenderProps) {
  const { pathname } = useLocation();
  const isArticlePage = useIsArticlePage();
  useDfpPreview();

  return (
    <div className="min-h-screen bg-secondary">
      {/* LB1 across all site */}
      <GoogleAd
        type={GoogleAdTypeEnum.LB1}
        className="border-y border-divider-primary bg-tertiary py-2"
      />
      {/* Catfish Ad */}
      <CatfishAd />

      <Header
        theme={pathname.includes("videos") ? ThemeEnum.dark : ThemeEnum.light}
        showShare={(isArticlePage && !pathname.includes("videos")) || false}
      />

      {children}

      <ScrollToTop />

      <Footer />
    </div>
  );
}
